import axios from "axios";

export default class InitiativeApi {
    constructor(apiURL) {
        this.apiClient = axios.create({
            baseURL: apiURL,
            withCredentials: false,
        });
    }

    request({ url, method = 'post', data = null, token = null, config = {} }) {
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        return this.apiClient.request({
            url,
            method,
            data,
            headers,
            ...config
        });
    }

    eSign(token, signatory) {
        return this.request({
            url: '/esign',
            method: 'post',
            data: { signatory },
            token
        });
    }
}
